import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import type { ReactNode } from "react";

export interface FullPageStatusProps {
  variant?: "loading" | "error" | "empty";
  title?: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}

/** Full-viewport-height status block for loading/error/empty states. */
export function FullPageStatus({
  variant = "loading",
  title,
  description,
  action,
}: FullPageStatusProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        minHeight: "40vh",
        textAlign: "center",
        padding: 4,
      }}
    >
      {variant === "loading" ? <CircularProgress /> : null}
      {title ? <Typography variant="h6">{title}</Typography> : null}
      {description ? (
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      ) : null}
      {action}
    </Box>
  );
}
